import React, { useEffect, useState } from "react";
import { Form, Select, Space } from "antd";
import { Button, Card } from "@comps";
import { Http, Message } from "@utils";

const Item = Form.Item;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

export interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  agent: JSONObject;
}

const SwitchInvoicer: React.FC<Props> = ({ onCancel, onConfirm, agent }) => {
  const [form] = Form.useForm();
  const [taxAccounts, setTaxAccounts] = useState<JSONObject[]>([]);

  useEffect(() => {
    Http.get<JSONObject[]>("/tax/agent-accounts").then((data) => {
      setTaxAccounts(data || []);
    });
  }, []);

  async function handleSave() {
    const { accountId } = await form.validateFields();
    const taxAccount = taxAccounts.find((item) => item.id === accountId);
    if (!taxAccount) {
      return;
    }

    await Http.put("/tax/agents/switch-invoicer", {
      agentId: agent.id,
      accountId: taxAccount.id,
    });
    Message.ok();
    onConfirm();
  }

  return (
    <Card title="切换开票员" style={{ marginBottom: "0" }}>
      <Form {...layout} form={form}>
        <Item label="办税人名称" name="accountId" rules={[{ required: true }]}>
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            options={taxAccounts
              .filter((taxAccount) => taxAccount.taxInvoicer)
              .map((taxAccount) => ({
                label: taxAccount.taxInvoicer,
                value: taxAccount.id,
              }))}
          />
        </Item>
        <div style={{ textAlign: "center" }}>
          <Space>
            <Button type="primary" clickCallback={handleSave}>
              保存
            </Button>
            <Button onClick={onCancel}>取消</Button>
          </Space>
        </div>
      </Form>
    </Card>
  );
};

export default SwitchInvoicer;
